"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DEPRECATED: Use ObservableFiniteStateMachine instead
 * Abstract class that defines the basic signature of a FiniteStateMachine:
 * - state: the current state of the FSM
 * - transitions: all possible method calls that will transition from one state to another
 * - subscriptions: list of connected components that shuold render when state changes
 */
class FiniteStateMachine {
    constructor() {
        /**
         * List of connected components that shuold render when state changes
         */
        this.subscriptions = [];
    }
    get state() { return this._state; }
    /**
     * Used by ConnectRenderer to subscribe a Component to FSM State Changes
     *
     * @param callback Function taking in (state, data) for rendering
     */
    subscribe(callback) {
        this.subscriptions.push(callback);
    }
    /**
     * Used by ConnectRenderer to unsubscribe a Component to FSM State Changes
     *
     * @param callback Function taking in (state, data) for rendering
     */
    unsubscribe(callback) {
        // Remove subscription
        if (this.subscriptions.includes(callback)) {
            this.subscriptions.filter((subscription) => subscription === callback);
            return;
        }
    }
    /**
     * SetState takes in (nextState, data).
     * Discussion: This would have just been a setter for state, but typescript/javascript does not have
     * support for enum associated values. So, we have a state "setter" called setState(state, data)
     *
     * @param nextState State for FSM to become
     * @param associatedValue Associated value for newState, defaults to null. Could be null, single value, object, etc.
     */
    setState(nextState, associatedValue = null) {
        this._state = nextState;
        this.notify(this._state, associatedValue);
    }
    /**
     * Notify informs subscribers about a new state change in state machine
     *
     * @param state State to render
     * @param data Associate state values - could be null, single value, or tuple
     */
    notify(state, associatedValue) {
        this.subscriptions.forEach((subscription) => subscription(state, associatedValue));
    }
}
exports.default = FiniteStateMachine;
//# sourceMappingURL=FiniteStateMachine.js.map